import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticClass: "app-upgrade-root"
  }, [_vm.appJsonData.android ? _c("a-descriptions", {
    staticStyle: {
      width: "500px"
    },
    attrs: {
      size: "small",
      layout: "vertical",
      column: 2,
      bordered: ""
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.appUpgrade.android")) + " "), _c("a-icon", {
    staticClass: "editable-cell-icon",
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.onEdit("android");
      }
    }
  })], 1), _c("a-descriptions-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.upgradeType")
    }
  }, [_vm._v(" " + _vm._s(_vm.appJsonData.android.force === 1 ? _vm.$t("deploy.appUpgrade.force") : _vm.$t("deploy.appUpgrade.noforce")) + " ")]), _c("a-descriptions-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.versionNumber")
    }
  }, [_vm._v(" " + _vm._s(_vm.appJsonData.android.versionCode) + " ")]), _c("a-descriptions-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.updateContent"),
      span: 2
    }
  }, [_vm.appJsonData.android.content ? _c("div", [_c("div", [_vm._v(_vm._s(_vm.$t("deploy.appUpgrade.chinese")) + "：" + _vm._s(_vm.appJsonData.android.content[2]))]), _c("div", [_vm._v(_vm._s(_vm.$t("deploy.appUpgrade.japanese")) + "：" + _vm._s(_vm.appJsonData.android.content[3]))]), _c("div", [_vm._v(_vm._s(_vm.$t("deploy.appUpgrade.traditional")) + "：" + _vm._s(_vm.appJsonData.android.content[4]))])]) : _vm._e()])], 1) : _vm._e(), _vm.appJsonData.ios ? _c("a-descriptions", {
    staticStyle: {
      width: "500px"
    },
    attrs: {
      size: "small",
      layout: "vertical",
      column: 2,
      bordered: ""
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.appUpgrade.ios")) + " "), _c("a-icon", {
    staticClass: "editable-cell-icon",
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.onEdit("ios");
      }
    }
  })], 1), _c("a-descriptions-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.upgradeType")
    }
  }, [_vm._v(" " + _vm._s(_vm.appJsonData.ios.force === 1 ? _vm.$t("deploy.appUpgrade.force") : _vm.$t("deploy.appUpgrade.noforce")) + " ")]), _c("a-descriptions-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.versionNumber")
    }
  }, [_vm._v(" " + _vm._s(_vm.appJsonData.ios.versionCode) + " ")]), _c("a-descriptions-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.updateContent"),
      span: 2
    }
  }, [_vm.appJsonData.ios.content ? _c("div", [_c("div", [_vm._v(_vm._s(_vm.$t("deploy.appUpgrade.chinese")) + "：" + _vm._s(_vm.appJsonData.ios.content[2]))]), _c("div", [_vm._v(_vm._s(_vm.$t("deploy.appUpgrade.japanese")) + "：" + _vm._s(_vm.appJsonData.ios.content[3]))]), _c("div", [_vm._v(_vm._s(_vm.$t("deploy.appUpgrade.traditional")) + "：" + _vm._s(_vm.appJsonData.ios.content[4]))])]) : _vm._e()])], 1) : _vm._e()], 1), _c("div", {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c("a-descriptions", {
    staticClass: "hideCode_table",
    staticStyle: {
      width: "500px"
    },
    attrs: {
      size: "small",
      column: 2,
      layout: "vertical",
      bordered: ""
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.appUpgrade.hideCodeTitle")) + " "), _c("a-icon", {
    staticClass: "editable-cell-icon",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.onEditHideCode
    }
  })], 1), _c("a-descriptions-item", {
    staticStyle: {
      width: "50%"
    },
    attrs: {
      label: "Android"
    }
  }, [_vm._v(" " + _vm._s(_vm.hideCodeJsonData.android) + " ")]), _c("a-descriptions-item", {
    staticStyle: {
      width: "50%"
    },
    attrs: {
      label: "IOS"
    }
  }, [_vm._v(" " + _vm._s(_vm.hideCodeJsonData.ios) + " ")])], 1)], 1), _vm.showEdit ? _c("a-modal", {
    attrs: {
      width: "500px",
      title: "".concat(_vm.$t("public.edit") + _vm.$t("deploy.appUpgrade." + _vm.editForm.type.toLowerCase())).concat(_vm.$t("deploy.appUpgrade.updateContent")),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.showEdit,
      callback: function callback($$v) {
        _vm.showEdit = $$v;
      },
      expression: "showEdit"
    }
  }, [_c("a-row"), _c("a-form-model", {
    ref: "ruleRemoveForm",
    attrs: {
      model: _vm.editForm
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.upgradeType")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function change($event) {}
    },
    model: {
      value: _vm.editForm.force,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "force", $$v);
      },
      expression: "editForm.force"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.appUpgrade.noforce")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.appUpgrade.force")) + " ")])], 1)], 1), _vm._l(_vm.langMap, function (lang, key) {
    return [_c("a-form-model-item", {
      attrs: {
        label: _vm.$t("deploy.appUpgrade.updateContent") + lang
      }
    }, [_c("a-textarea", {
      attrs: {
        rows: 4
      },
      model: {
        value: _vm.editForm.content[key],
        callback: function callback($$v) {
          _vm.$set(_vm.editForm.content, key, $$v);
        },
        expression: "editForm.content[key]"
      }
    })], 1)];
  }), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.versionNumber")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      id: "inputNumber",
      placeholder: _vm.$t("publicuse.placeinput")
    },
    model: {
      value: _vm.editForm.versionCode,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "versionCode", $$v);
      },
      expression: "editForm.versionCode"
    }
  })], 1)], 2), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        _vm.showEdit = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onEditConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")) + " ")])], 1)], 2) : _vm._e(), _c("a-modal", {
    attrs: {
      width: "500px",
      title: _vm.$t("public.edit") + _vm.$t("deploy.appUpgrade.hideCodeTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.showEditHideCode,
      callback: function callback($$v) {
        _vm.showEditHideCode = $$v;
      },
      expression: "showEditHideCode"
    }
  }, [_c("a-form-model", {
    attrs: {
      model: _vm.editHideCodeForm
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.android")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("publicuse.placeinput")
    },
    model: {
      value: _vm.editHideCodeForm.android,
      callback: function callback($$v) {
        _vm.$set(_vm.editHideCodeForm, "android", $$v);
      },
      expression: "editHideCodeForm.android"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("deploy.appUpgrade.ios")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("publicuse.placeinput")
    },
    model: {
      value: _vm.editHideCodeForm.ios,
      callback: function callback($$v) {
        _vm.$set(_vm.editHideCodeForm, "ios", $$v);
      },
      expression: "editHideCodeForm.ios"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        _vm.showEditHideCode = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.saveAppUpgradeDataLoading
    },
    on: {
      click: _vm.onEditHideCodeConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")) + " ")])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };